import { render, staticRenderFns } from "./auctionsOverview.vue?vue&type=template&id=16a7a2dc&scoped=true&"
import script from "./auctionsOverview.vue?vue&type=script&lang=js&"
export * from "./auctionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./auctionsOverview.vue?vue&type=style&index=0&id=16a7a2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7a2dc",
  null
  
)

export default component.exports